import React from 'react';
import { Check } from 'lucide-react';
import { CommandItem } from '@/components/ui/command';
import { cn } from '@/lib/utils';
import { SingleSelectOption } from '@/components/ui/single-select';
import { GetSlateReportPredictions } from '../../../api/slate-report';

interface PredictionItemProps {
  option: SingleSelectOption<string> & {
    prediction?: GetSlateReportPredictions.Prediction;
  };
  isSelected: boolean;
  onClick: () => void;
}

const PredictionItem: React.FC<PredictionItemProps> = ({
  option,
  isSelected,
  onClick,
}) => {
  const prediction = option.prediction;
  if (!prediction) return null;

  return (
    <CommandItem
      key={option.value}
      value={option.value}
      onSelect={onClick}
      className="tw-flex tw-items-center tw-justify-between tw-p-3 tw-cursor-pointer hover:tw-bg-gray-50 tw-min-h-[3.5rem] tw-border-b tw-border-gray-100 last:tw-border-b-0"
    >
      <div className="tw-flex tw-flex-col tw-gap-1 tw-flex-1 tw-min-w-0">
        <div className="tw-flex tw-items-center tw-justify-between">
          <span className="tw-font-semibold tw-text-gray-900 tw-text-sm">
            {prediction.version}
          </span>
          <span className="tw-px-2 tw-py-0.5 tw-bg-blue-100 tw-text-blue-800 tw-text-xs tw-font-medium tw-rounded-full">
            {new Date(prediction.date).toLocaleDateString()}
          </span>
        </div>
        <div className="tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-gray-600">
          <span>
            <span className="tw-font-medium tw-text-green-700">
              ${(prediction.box_office_gross / 1000000).toFixed(1)}M
            </span>{' '}
            WW B.O.
          </span>
          <span>
            <span className="tw-font-medium tw-text-purple-700">
              {prediction.box_office_multiple.toFixed(1)}x
            </span>{' '}
            B.O.M.
          </span>
        </div>
      </div>
      <div
        className={cn(
          'tw-h-4 tw-w-4 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-ml-3',
          isSelected ? 'tw-text-blue-600' : 'tw-text-transparent',
        )}
      >
        <Check className="tw-h-3 tw-w-3" />
      </div>
    </CommandItem>
  );
};

export default PredictionItem;